/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetNewValidFiltersQueryVariables = Types.Exact<{
  q: Types.Scalars["String"]["input"];
  filters?: Types.InputMaybe<Array<Types.FreestyleSearchFilterInput> | Types.FreestyleSearchFilterInput>;
}>;
export type GetNewValidFiltersQuery = {
  __typename?: "Query";
  shopContent?: {
    __typename?: "ShopContent";
    id: string;
    search?: {
      __typename?: "FreestyleSearch";
      id: string;
      filters: Array<{
        __typename?: "FreestyleSearchFilter";
        id: string;
        label: string;
        menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
        options: Array<{
          __typename?: "FreestyleSearchFilterColorOption";
          hex: string;
          selected: boolean;
          label: string;
          value: string;
        } | {
          __typename?: "FreestyleSearchFilterTextOption";
          selected: boolean;
          label: string;
          value: string;
        }>;
      }>;
    } | null;
  } | null;
};
export type ValidFiltersSearchFragment = {
  __typename?: "FreestyleSearch";
  id: string;
  filters: Array<{
    __typename?: "FreestyleSearchFilter";
    id: string;
    label: string;
    menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
    options: Array<{
      __typename?: "FreestyleSearchFilterColorOption";
      hex: string;
      selected: boolean;
      label: string;
      value: string;
    } | {
      __typename?: "FreestyleSearchFilterTextOption";
      selected: boolean;
      label: string;
      value: string;
    }>;
  }>;
};
export type SelectedFilterFragment = {
  __typename?: "FreestyleSearchFilter";
  id: string;
  label: string;
  menuDisplayTemplate: Types.FreestyleSearchFilterDisplayTemplate;
  options: Array<{
    __typename?: "FreestyleSearchFilterColorOption";
    hex: string;
    selected: boolean;
    label: string;
    value: string;
  } | {
    __typename?: "FreestyleSearchFilterTextOption";
    selected: boolean;
    label: string;
    value: string;
  }>;
};
export const SelectedFilterFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "SelectedFilter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "FragmentSpread",
        name: {
          kind: "Name",
          value: "Filter"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "selected"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Filter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "label"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "menuDisplayTemplate"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FreestyleSearchFilterColorOption"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const ValidFiltersSearchFragmentDoc = {
  kind: "Document",
  definitions: [{
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ValidFiltersSearch"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearch"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "filters"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "SelectedFilter"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Filter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "label"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "menuDisplayTemplate"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FreestyleSearchFilterColorOption"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "SelectedFilter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "FragmentSpread",
        name: {
          kind: "Name",
          value: "Filter"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "selected"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export const GetNewValidFiltersDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "query",
    name: {
      kind: "Name",
      value: "getNewValidFilters"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "q"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "String"
          }
        }
      }
    }, {
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "filters"
        }
      },
      type: {
        kind: "ListType",
        type: {
          kind: "NonNullType",
          type: {
            kind: "NamedType",
            name: {
              kind: "Name",
              value: "FreestyleSearchFilterInput"
            }
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "shopContent"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "id"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "search"
            },
            arguments: [{
              kind: "Argument",
              name: {
                kind: "Name",
                value: "input"
              },
              value: {
                kind: "ObjectValue",
                fields: [{
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "query"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "q"
                    }
                  }
                }, {
                  kind: "ObjectField",
                  name: {
                    kind: "Name",
                    value: "filters"
                  },
                  value: {
                    kind: "Variable",
                    name: {
                      kind: "Name",
                      value: "filters"
                    }
                  }
                }]
              }
            }],
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "FragmentSpread",
                name: {
                  kind: "Name",
                  value: "ValidFiltersSearch"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "Filter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "label"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "menuDisplayTemplate"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "label"
            }
          }, {
            kind: "Field",
            name: {
              kind: "Name",
              value: "value"
            }
          }, {
            kind: "InlineFragment",
            typeCondition: {
              kind: "NamedType",
              name: {
                kind: "Name",
                value: "FreestyleSearchFilterColorOption"
              }
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "hex"
                }
              }]
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "SelectedFilter"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearchFilter"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "FragmentSpread",
        name: {
          kind: "Name",
          value: "Filter"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "options"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "selected"
            }
          }]
        }
      }]
    }
  }, {
    kind: "FragmentDefinition",
    name: {
      kind: "Name",
      value: "ValidFiltersSearch"
    },
    typeCondition: {
      kind: "NamedType",
      name: {
        kind: "Name",
        value: "FreestyleSearch"
      }
    },
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "id"
        }
      }, {
        kind: "Field",
        name: {
          kind: "Name",
          value: "filters"
        },
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: "SelectedFilter"
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;

/**
 * __useGetNewValidFiltersQuery__
 *
 * To run a query within a React component, call `useGetNewValidFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewValidFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewValidFiltersQuery({
 *   variables: {
 *      q: // value for 'q'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetNewValidFiltersQuery(baseOptions: Apollo.QueryHookOptions<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables> & ({
  variables: GetNewValidFiltersQueryVariables;
  skip?: boolean;
} | {
  skip: boolean;
})) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useQuery<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>(GetNewValidFiltersDocument, options);
}
export function useGetNewValidFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useLazyQuery<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>(GetNewValidFiltersDocument, options);
}
// @ts-ignore
export function useGetNewValidFiltersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>;
export function useGetNewValidFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>): Apollo.UseSuspenseQueryResult<GetNewValidFiltersQuery | undefined, GetNewValidFiltersQueryVariables>;
export function useGetNewValidFiltersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useSuspenseQuery<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>(GetNewValidFiltersDocument, options);
}
export type GetNewValidFiltersQueryHookResult = ReturnType<typeof useGetNewValidFiltersQuery>;
export type GetNewValidFiltersLazyQueryHookResult = ReturnType<typeof useGetNewValidFiltersLazyQuery>;
export type GetNewValidFiltersSuspenseQueryHookResult = ReturnType<typeof useGetNewValidFiltersSuspenseQuery>;
export type GetNewValidFiltersQueryResult = Apollo.QueryResult<GetNewValidFiltersQuery, GetNewValidFiltersQueryVariables>;